import React, {useEffect} from "react"
import {useInstantSearch} from "react-instantsearch"
const Listener = () => {

  const {setIndexUiState} = useInstantSearch()
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data.type === "filterRefine") {
        setIndexUiState((prevUiState) => ({
          ...prevUiState, refinementList: {
            ...prevUiState.refinementList,
            [event.data.attribute]: [event.data.value],
          },
        }))
      }
    })
  }, [])
  return (<></>)
}
export default Listener
